import RxQuery from 'utils/api/rxQuery/rxQuery';
import endpoints from 'utils/api/endpoints';
import { getCartProducts, IAddItemsToCartPayload, IValidateCart, validateCartItems } from '../payloads/eshopApi';
import { deleteSingleCartItem } from '../payloads/eshopApi';

const eshopWCSApi = () => new RxQuery('eshopWCSApi');

export const getInventoryByProductId = (productId: string): RxQuery => {
	return eshopWCSApi()
		.setEndpoint(endpoints.eshopApi.products.getInventoryByProductId.getInventoryByProductId(productId))
		.setType('inventoryByProductId');
};

export const addItemsToCart = (items: IAddItemsToCartPayload[]): RxQuery => {
	return eshopWCSApi()
		.setEndpoint(endpoints.eshopApi.products.cart.addToCart())
		.setPayload(getCartProducts(items))
		.disableCache()
		.setEshopIdentity();
};

export const validateCart = (payload: IValidateCart): RxQuery => {
	return eshopWCSApi()
		.setEndpoint(endpoints.eshopApi.products.cart.validateCart())
		.setPayload(validateCartItems(payload))
		.setType('validateCart')
		.disableCache()
		.setEshopIdentity();
};

export const viewCart = (WCTrustedToken?: string, WCToken?: string, WCPersonalization?: string): RxQuery => {
	return eshopWCSApi()
		.setEndpoint(endpoints.eshopApi.products.cart.viewCart())
		.disableCache()
		.setType('viewCart')
		.setEshopIdentity(WCTrustedToken, WCToken, WCPersonalization);
};

export const clearAllCartItems = (): RxQuery => {
	return eshopWCSApi()
		.disableCache()
		.setEndpoint(endpoints.eshopApi.products.cart.clearAllCartItems())
		.setEshopIdentity();
};

export const removeSingleCartItem = (orderItemId: string): RxQuery => {
	return eshopWCSApi()
		.setPayload(deleteSingleCartItem(orderItemId))
		.disableCache()
		.setEndpoint(endpoints.eshopApi.products.cart.removeSingleCartItem())
		.setEshopIdentity();
};

export const getOmantelIdentity = (): RxQuery => {
	return eshopWCSApi()
		.setEndpoint(endpoints.eshopApi.products.getIdentity.getIdentity())
		.setPayload({})
		.disableCache()
		.setType('guestLogIn');
};

export const getPurchaseDeviceOrder = (orderId: any): RxQuery => {
	return eshopWCSApi()
		.setEndpoint(endpoints.eshopApi.products.getPurchaseDeviceOrder.getPurchaseDeviceOrder(orderId))
		.setEshopIdentity();
};
